import PropTypes from 'prop-types'
import React, { Component } from 'react'
import cx from 'classnames'

import Accordion from 'components/settings/Accordion'
import style from './style.styl'

class ClickThroughAccordion extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  static propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    redirectToUrl: PropTypes.string.isRequired,
    hoverText: PropTypes.string
  }

  static defaultProps = {
    hoverText: "View"
  }

  render() {
    const { title, description, hoverText, redirectToUrl } = this.props
    const { push } = this.context.router

    return (
      <div className={cx(style.ClickThroughAccordion)}>
        <Accordion
          title={title}
          description={description}
          rightContent={
            <span>{hoverText}</span>
          }
          locked
          onToggle={() => push(redirectToUrl)}
        />
      </div>
    )
  }
}

export default ClickThroughAccordion



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ClickThroughAccordion/index.js